import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import '../../../Tabs/ToggleSwitch.css';  // Import your CSS for the toggle switch
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';  // To generate unique request IDs
import { horizontalApi, serviceApi, ManagerlApi, baseApi } from '../../../../API/api';  // Make sure to import your API URL

const HorizontalCurvesTab = ({onSave}) => {
  const [step, setStep] = useState(1);
  const [isReport, setIsReport] = useState(false);
  const [dbName, setDbName] = useState('');
  const [collectionName, setCollectionName] = useState('');
  const [outputFolder, setOutputFolder] = useState('');
  const [horizontalData, setHorizontalData] = useState(null);
  const [rows, setRows] = useState([{ Start: '', End: '', Speed: '' }]);
  const [additionalData, setAdditionalData] = useState({
    project_name: '',
    state: '',
    road_number: '',
    start_mile: '',
    end_mile: '',
    job_number: '',
    corridor: ''
  });
  const [submittedData, setSubmittedData] = useState(null);
  const [formErrors, setFormErrors] = useState(''); // Error message state

  const getFormattedTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleAddRow = () => {
    setRows([...rows, { Start: '', End: '', Speed: '' }]);
  };

  const handleRemoveRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  const handleChange = (index, field, value) => {
    const newRows = [...rows];
  
    if (['Start', 'End', 'Speed'].includes(field)) {
      newRows[index][field] = isNaN(value) ? '' : value;
    } else {
      newRows[index][field] = value;
    }
  
    setRows(newRows);
  };

  const handleAdditionalDataChange = (field, value) => {
    setAdditionalData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const extractFolderId = (url) => {
    const parts = url.split('/');
    setOutputFolder(parts[parts.length - 1]);
  };

  const handleToggle = () => {
    setIsReport(!isReport);
    if (!isReport) {
      resetForm();
    }
    handleClean()
  };

  const resetForm = () => {
    setStep(1);
    setAdditionalData({
      project_name: '',
      state: '',
      road_number: '',
      start_mile: '',
      end_mile: '',
      job_number: '',
      corridor: ''
    });
    setOutputFolder('');  // Clear output folder
    setSubmittedData(null);
    setFormErrors(''); // Clear errors
  };

  const validateForm = () => {
    const { project_name, state, road_number, start_mile, end_mile, job_number, corridor } = additionalData;
    const errors = [];

    if (!project_name) errors.push('Project Name');
    if (!state) errors.push('State');
    if (!road_number) errors.push('Road Number');
    if (!start_mile) errors.push('Start Mile');
    if (!end_mile) errors.push('End Mile');
    if (!job_number) errors.push('Job Number');
    if (!corridor) errors.push('Corridor');
    if (!outputFolder) errors.push('Report Output Folder');

    if (errors.length > 0) {
      setFormErrors('Please fill out all the fields');
      return false;
    } else {
      setFormErrors('');
      return true;
    }
  };

  const handleDone = () => {
    if (validateForm()) {
      const payload = {
        ...additionalData,
        database_name: dbName,
        collection_name: collectionName,
        output_drive_folder_id: outputFolder,
        report: isReport,
        speed_table: rows.map((row) => ({
          Start: isNaN(parseInt(row.Start, 10)) ? '' : parseInt(row.Start, 10),
          End:   isNaN(parseInt(row.End,   10)) ? '' : parseInt(row.End,   10),
          Speed: isNaN(parseInt(row.Speed, 10)) ? '' : parseInt(row.Speed, 10),
        })),
      };
      setSubmittedData(payload);
      setSubmittedData(payload);       // optional: keep your existing summary state
      setHorizontalData(payload);      // ← now your “horizontalData” holds everything
      onSave(payload);
      setStep(1);  // Reset wizard step (if that’s still desired)
    }
  };

  const handleClean = () => {
    resetForm();  // Reset all the form data
  };

  return (
    <div className='HorizontalContentRSA'>
      <div style={{ width: '90%' }} className='start'>
        {/* Database Name Input */}
        <div>
        <h2>Enter Horizontal Details:</h2>
        
          <label>Database Name:</label>
          <input
            type="text"
            value={dbName}
            onChange={(e) => setDbName(e.target.value)}
          />
        </div>

        {/* Collection Name Input */}
        <div>
          <label>Collection Name:</label>
          <input
            type="text"
            value={collectionName}
            onChange={(e) => setCollectionName(e.target.value)}
          />
        </div>

        {/* Speed Table Inputs */}
        <div className="Speed-table">
          <div className="DF">
            <label>Speed Table:</label>
          </div>
          {rows.map((row, index) => (
            <div style={{ width: '115%'}} 
            
            key={index}>
          <input
            type="text"
            placeholder="Start"
            value={row.Start}
            onChange={(e) => handleChange(index, 'Start', e.target.value)}
            style={{ width: '70px' }}
          />
          <input
            type="text"
            placeholder="End"
            value={row.End}
            onChange={(e) => handleChange(index, 'End', e.target.value)}
            style={{ width: '70px' }}
          />
          <input
            type="text"
            placeholder="Speed"
            value={row.Speed}
            onChange={(e) => handleChange(index, 'Speed', e.target.value)}
            style={{ width: '70px' }}
          />

              {rows.length > 1 && (
                // <button onClick={() => handleRemoveRow(index)}>
                  <FaTrash onClick={() => handleRemoveRow(index)} style={{ color: 'red', cursor: 'pointer' }} />
                // </button>
              )}
            </div>
          ))}
          <p 
            style={{
              color: '#DD4130', 
              cursor: 'pointer',
              transition: 'color 0.2s ease'
            }} 
            onMouseEnter={(e) => e.target.style.color = '#ff6b6b'}
            onMouseLeave={(e) => e.target.style.color = '#DD4130'}
            onClick={handleAddRow}
          >
            Add row
          </p>
        </div>
      </div>

      {/* Wizard for Report Data */}
      {(
        <div className="wizard-container">
         <div className="form-errors">
           {formErrors && <p style={{ color: 'red' }}>{formErrors}</p>}
         </div>
         <h2>Enter Report Details</h2>
         <label>Project Name</label>
         <input
           type="text"
           value={additionalData.project_name}
           onChange={(e) => handleAdditionalDataChange('project_name', e.target.value)}
         />
         <label>State</label>
         <input
           type="text"
           value={additionalData.state}
           onChange={(e) => handleAdditionalDataChange('state', e.target.value)}
         />
         <label>Road Number</label>
         <input
           type="text"
           value={additionalData.road_number}
           onChange={(e) => handleAdditionalDataChange('road_number', e.target.value)}
         />
         <label>Start Mile</label>
         <input
           type="text"
           value={additionalData.start_mile}
           onChange={(e) => handleAdditionalDataChange('start_mile', e.target.value)}
         />
         <label>End Mile</label>
         <input
           type="text"
           value={additionalData.end_mile}
           onChange={(e) => handleAdditionalDataChange('end_mile', e.target.value)}
         />
         <label>Job Number</label>
         <input
           type="text"
           value={additionalData.job_number}
           onChange={(e) => handleAdditionalDataChange('job_number', e.target.value)}
         />
         <label>Corridor</label>
         <input
           type="text"
           value={additionalData.corridor}
           onChange={(e) => handleAdditionalDataChange('corridor', e.target.value)}
         />
         <label>Report Output Folder</label>
         <input
           type="text"
           placeholder="Google Drive Folder URL"
           value={outputFolder}
           onChange={(e) => extractFolderId(e.target.value)}
         />

         <div className="button-container">
           <button onClick={handleDone}>Save</button>
         </div>
       </div>
      )}


    </div>
  );
};

export default HorizontalCurvesTab;
